import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {RequestCreateActivityDto} from "../dto/activity.dto";
import {Observable} from "rxjs";

@Injectable()
export class ActivityApi {
  private service: string = '';
  private model: string = 'activity';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  createActivity(data: RequestCreateActivityDto):Observable<any>{
    const method: string = 'POST';
    const func: string = 'createActivity';
    const params: RequestCreateActivityDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/activity.api.ts